export function getPageSlugFromPathname(pathname) {
    const segments = (pathname || "").split("/").filter(Boolean);

    // /en/ -> login
    if (segments.length <= 1) {
        return "login";
    }

    // /en/stats/history|review|reports -> history|review|reports
    if (segments[1] === "stats" && segments[2]) {
        return segments[2];
    }

    // default /en/<page>
    return segments[1];
}